import React from "react";
import Image from "next/image";
import { Button } from "@/components/Button";
import Link from "next/link";
import { AnimatedWrapper, AnimationsEnum } from "../AnimatedWrapper";
import { env } from "@/config/env";

export type PRODUCTS_PAGE = "WALLETS" | "MERCHANTS" | "TICKETING";
export type HeroProps = {
  title: string;
  description: string;
  image: string;
  highlight: string;
  bgImage?: boolean;
  buttonText: string;
};

export default function ProductsHeroSection({
  title,
  description,
  image,
  highlight,
  bgImage,
  buttonText,
}: HeroProps) {
  const [before, after] = title.split(highlight);
  return (
    <div className="flex justify-center md:flex-row flex-col-reverse items-center w-full">
      <AnimatedWrapper
        animationType={AnimationsEnum.FadeInLeft}
        className="flex justify-center md:flex-row flex-col-reverse items-center mb-10 md:w-4/5"
      >
        <div className="flex flex-col  mt-10">
          <div className="flex flex-col w-full xl:w-4/5 gap-6 mt-16">
            <h1 className="md:text-[50px] text-3xl text-secondary-900 font-medium leading-tight font-poppins">
              {before}{" "}
              <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
                {highlight}
              </span>{" "}
              {after}
            </h1>
            <span className="text-secondary-900 font-medium text-lg md:w-3/5 font-montserrat">
              {description}
            </span>
          </div>

          <div className="mt-10 z-10 relative">
            <Link
              href={env.DASHBOARD_LOG_IN_URL}
              className="bg-gradient-to-r from-[#4337cc] to-primary-900 border-[#3F26C6] rounded-lg py-3 md:py-2 px-8 inline-block font-semibold text-white hover:scale-[1.05] transition-all"
            >
              {buttonText}
            </Link>
          </div>
        </div>
      </AnimatedWrapper>

      <div className="p-8 w-2/5 flex relative">
        <Image
          priority
          src={image}
          alt="Products Hero Background Image"
          height={500}
          width={1000}
          className="object-contain md:flex hidden w-[700px] h-[500px]"
        />
        {bgImage && (
          <Image
            priority
            src={"/images/products/products-hero-background.png"}
            alt="Products Hero Background Image"
            height={300}
            width={500}
            className="object-contain absolute -z-20 bottom-0 md:flex hidden w-[500px] h-[300px]"
          />
        )}
      </div>
    </div>
  );
}
